import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover esta liberacão de acesso?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/resources/computed.js